import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import LinkedInSidebar from '../LinkedInSidebar';
import axios from "axios";
import Cookies from "js-cookie";
import { Bell, Settings } from "lucide-react";
import Modal from '../Elements/Modal';
import TableFromJson from '../Elements/TableFromJson';
import ReactMarkdown from 'react-markdown';
import NotificationCustomSettingsLine from './NotificationCustomSettingsLine';

const Notification = ({ currentPage, setCurrentPage, company_id, auth_status, notification_enabled }) => {
  
  const [loading, setLoading] = useState(false);
  const [isNotificationEnabled, setIsNotificationEnabled] = useState(notification_enabled);
  const [isCustom, setIsCustom] = useState(false);
  const [settingsSaved, setSettingsSaved] = useState(false);
  const [error, setError] = useState('');
  
  

  const [notificationSettings, setNotificationSettings] = useState({
    type: "standard",
    success_rate: {
      "enabled": true,
      "from": 75,
      "to": 100
    },
    pe: {
      "enabled": false,
      "from": 0,
      "to": 15
    },
    pcf: {
      "enabled": false,
      "from": 0,
      "to": 10
    },
    ps: {
      "enabled": false,
      "from": 0,
      "to": 2
    },
    operating_ratio: {
      "enabled": false,
      "from": 0,
      "to": 85
    },
    npm: {
      "enabled": false,
      "from": 15,
      "to": 100
    },
    dar: {
      "enabled": false,
      "from": 0,
      "to": 1
    },
    cr: {
      "enabled": false,
      "from": 1,
      "to": 100
    },
    roe: {
      "enabled": false,
      "from": 15,
      "to": 100
    },
    pbr: {
      "enabled": false,
      "from": 0,
      "to": 1.5
    },
    odp: {
      "enabled": false,
      "from": 1,
      "to": 100
    }
  });

  useEffect(() => {
    setIsNotificationEnabled(notification_enabled);
  }, [notification_enabled]);

  useEffect(() => {
    if(isCustom === false) {
      changeNotificationSettings("standard","type");
      changeNotificationSettings("75","success_rate","from");
      changeNotificationSettings("100","success_rate","to");
      changeNotificationSettings(false,"pe","enabled");
      changeNotificationSettings(false,"pcf","enabled");
      changeNotificationSettings(false,"ps","enabled");
      changeNotificationSettings(false,"operating_ratio","enabled");
      changeNotificationSettings(false,"npm","enabled");
      changeNotificationSettings(false,"dar","enabled");
      changeNotificationSettings(false,"cr","enabled");
      changeNotificationSettings(false,"roe","enabled");
      changeNotificationSettings(false,"pbr","enabled");
      changeNotificationSettings(false,"odp","enabled");
    } else {
      changeNotificationSettings("custom","type");
      changeNotificationSettings("75","success_rate","from");
      changeNotificationSettings("100","success_rate","to");
      changeNotificationSettings(false,"pe","enabled");
      changeNotificationSettings(false,"pcf","enabled");
      changeNotificationSettings(false,"ps","enabled");
      changeNotificationSettings(false,"operating_ratio","enabled");
      changeNotificationSettings(false,"npm","enabled");
      changeNotificationSettings(false,"dar","enabled");
      changeNotificationSettings(false,"cr","enabled");
      changeNotificationSettings(false,"roe","enabled");
      changeNotificationSettings(false,"pbr","enabled");
      changeNotificationSettings(false,"odp","enabled");
    }
  }, [isCustom]);

  const changeNotificationSettings = (
    value,
    mainKey,
    subKey=null
  ) => {
    setNotificationSettings((prev) => {
      // Если это вложенное поле, например success_rate.from
      if (subKey && typeof prev[mainKey] === 'object' && prev[mainKey] !== null) {
        return {
          ...prev,
          [mainKey]: {
            ...(prev[mainKey]),
            [subKey]: value
          }
        };
      }
  
      // Если это верхнеуровневое поле, например type
      return {
        ...prev,
        [mainKey]: value
      };
    });

    console.log("notificationSettings: ", notificationSettings)
  };
  

  async function enableNotification() {
    if(auth_status === false) {
      setCurrentPage('auth/login');
      return ""
    }

    setLoading(true);

    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiURL}/user-notifications-company/enable`, { token: Cookies.get('token'), company_id: company_id, settings: notificationSettings });
      console.log("enableNotification: ", response.data)

      if(response.data.status == 'ok') {
        setIsNotificationEnabled(true);
      } else {
        if(response.data.type = 'free_limit_reached') {
          setError(response.data.message);
        }
      }

    } catch (error) {
      console.error("Error sending POST request:", error);
    } finally {
      setLoading(false);
    }

  }

  async function disableNotification() {
    if(auth_status === false) {
      setCurrentPage('auth/login');
      return ""
    }

    setLoading(true);

    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiURL}/user-notifications-company/disable`, { token: Cookies.get('token'), company_id: company_id });

      if(response.data.status == 'ok') {
        setIsNotificationEnabled(false);
      }

    } catch (error) {
      console.error("Error sending POST request:", error);
    } finally {
      setLoading(false);
    }
  }

  async function saveNotificationSettings() {
    if(auth_status === false) {
      setCurrentPage('auth/login');
      return ""
    }

    setLoading(true);

    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiURL}/user-notifications-company/save-settings`, { token: Cookies.get('token'), company_id: company_id, settings: notificationSettings });

      if(response.data.status == 'ok') {
        setIsNotificationEnabled(true);
        setLoading(false);
        setSettingsSaved(true);
        await delay(3000);
        setSettingsSaved(false);
      }

    } catch (error) {
      console.error("Error sending POST request:", error);
    } finally {
      setLoading(false);
    }
  }

  const delay = (ms) => new Promise(
    resolve => setTimeout(resolve, ms)
  );

  async function getNotificationSettings() {
    if(auth_status === false) {
      // setCurrentPage('auth/login');
      return ""
    }

    setLoading(true);

    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiURL}/user-notifications-company/get-settings`, { token: Cookies.get('token'), company_id: company_id });
      console.log("getNotificationSettings: ", response.data)

      if(response.data.status == 'ok') {
        if(response.data.empty == false) {
          {response.data.settings != null} {
            setNotificationSettings(response.data.settings);

            if(response.data.settings.type == "standard") {
              setIsCustom(false);
            } else {
              setIsCustom(true);
            }
          }
          
        }
      }

    } catch (error) {
      console.error("Error sending POST request:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getNotificationSettings()
  }, []);


  return (
    <div className="linkedin-card">
      <div className="linkedin-card-header">
        <h2 className="text-xl font-bold text-gray-900">Notification</h2>
        <div className="font-regular text-left text-xs">
          Receive notifications about this company when its evaluation changes.
        </div>
      </div>
      <div className="linkedin-card-content">

        {/* <div className="mx-auto w-fit mt-3">
          <button 
            onClick={() => setCurrentPage('auth/login')}
            className="linkedin-btn-primary text-sm px-4 py-1.5"
          >
            Enable Notification
          </button>
        </div> */}

        {isNotificationEnabled === false  && (
          <button onClick={() => enableNotification()} className={`linkedin-btn-primary text-sm text-white rounded-lg w-full flex justify-center items-center ${loading === true ? 'opacity-50' : ''} `} disabled={loading}><Bell className="text-white w-4 h-4 mr-2" />
            {loading === false && (
              <span>Enable Notification</span>
            )}
            {loading === true && (
              <span>Loading...</span>
            )}
          </button>
        )}
        {isNotificationEnabled === true && (
          <button onClick={() => disableNotification()} className="bg-gray-300 text-gray-400 font-medium rounded-2xl py-2 w-full flex justify-center items-center"><Bell className="text-gray-400 w-4 h-4 mr-2" />
            {loading === false && (
              <span>Disable Notification</span>
            )}
            {loading === true && (
              <span>Loading...</span>
            )}
          </button>
        )}

        {error != "" && (
          <div className="linkedin-metric-value">
            <div className="mt-5 w-full bg-red-100 rounded-md p-3">
              <p className="text-sm font-main-medium text-black">{error}</p>
            </div>
            <div className="mx-auto w-fit">
              <button onClick={() => setCurrentPage('subscriptions')} className="mt-3 linkedin-btn-secondary">Subscribe to Pro</button>
            </div>
          </div>
        )}

        {isNotificationEnabled === true && (
          <>
            <p className="mt-2 text-sm text-gray-600 font-bold">Settings</p>
            <span className="text-xs text-gray-500">
              Choose your preferred notification settings: Standard or Custom.
            </span>

            <div className="mt-4 flex items-center">
              <button
                onClick={() => setIsCustom(!isCustom)}
                className={`relative inline-flex items-center h-6 w-11 rounded-full transition-colors duration-300 ${
                  isCustom ? 'bg-blue-600' : 'bg-gray-300'
                }`}
              >
                <span
                  className={`inline-block w-4 h-4 transform bg-white rounded-full transition-transform duration-300 ${
                    isCustom ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </button>

              <span className="ml-3 text-sm text-gray-600 font-medium">
                {isCustom ? 'Custom' : 'Standard'}
              </span>
            </div>

            {isCustom === false && (
              <p className="mt-2 text-sm text-gray-600 font-medium">Success Rate: 75-100%</p>
            )}

            {isCustom === true && (
              <>
                <p className="mt-4 text-sm text-gray-600 font-medium">Success Rate ({notificationSettings.success_rate.from}-{notificationSettings.success_rate.to}%)</p>
                <div className="flex justify-between gap-2 w-full">
                  <input
                    type="email"
                    value={notificationSettings.success_rate.from}
                    onChange={(e) => changeNotificationSettings(e.target.value, "success_rate", "from")}
                    placeholder="From"
                    className="bg-transparent text-sm text-center font-medium placeholder:text-sm placeholder:font-light border rounded-md w-full px-2 py-2"
                  />

                  <input
                    type="email"
                    value={notificationSettings.success_rate.to}
                    onChange={(e) => changeNotificationSettings(e.target.value, "success_rate", "to")}
                    placeholder="To"
                    className="bg-transparent text-sm text-center font-medium placeholder:text-sm placeholder:font-light border rounded-md w-full px-2 py-2"
                  />
                </div>

                <NotificationCustomSettingsLine name="PE Ratio" mainKey="pe" settings={notificationSettings} changeNotificationSettings={changeNotificationSettings} />
                <NotificationCustomSettingsLine name="PCF Ratio" mainKey="pcf" settings={notificationSettings} changeNotificationSettings={changeNotificationSettings} />
                <NotificationCustomSettingsLine name="Operation Ration" mainKey="operating_ratio" settings={notificationSettings} changeNotificationSettings={changeNotificationSettings} />
                <NotificationCustomSettingsLine name="NPM" mainKey="npm" settings={notificationSettings} changeNotificationSettings={changeNotificationSettings} />
                <NotificationCustomSettingsLine name="DAR" mainKey="dar" settings={notificationSettings} changeNotificationSettings={changeNotificationSettings} />
                <NotificationCustomSettingsLine name="Current Ratio" mainKey="cr" settings={notificationSettings} changeNotificationSettings={changeNotificationSettings} />
                <NotificationCustomSettingsLine name="ROE" mainKey="roe" settings={notificationSettings} changeNotificationSettings={changeNotificationSettings} />
                <NotificationCustomSettingsLine name="PBR" mainKey="pbr" settings={notificationSettings} changeNotificationSettings={changeNotificationSettings} />
                <NotificationCustomSettingsLine name="ODP" mainKey="odp" settings={notificationSettings} changeNotificationSettings={changeNotificationSettings} />

              </>
            )}

            <button onClick={() => saveNotificationSettings()} className={`mt-4 linkedin-btn-primary text-sm text-white font-medium rounded-lg w-full py-2 flex justify-center ${loading === true ? 'opacity-50' : ''} `} disabled={loading}><Settings className="text-white w-4 h-4 mr-2 mt-0.5" />
              {loading === false && (
                <span>Save Settings</span>
              )}
              {loading === true && (
                <span>Loading...</span>
              )}
            </button>

            {settingsSaved == true && (
              <div className="mt-1 bg-green-300 rounded-md text-center text-sm text-green-700 py-1">
                <span>The settings have been saved successfully</span>
              </div>
            )}
            
          </>
        )}


      </div>
    </div>
  );
};

export default Notification;
